<template>
    <section class="login-outer-container d-flex justify-center align-center">
        <div style="width:500px">
             <v-container v-if="$announcement == true">
                <v-row dense>
                    <v-col cols="12">
                         <!-- <v-card class="login-vcard" style="background:green;padding:10px">
                           
                            <p style="font-size:20px"> <v-icon style="margin-right:20px;margin-top:-5px">mdi-bullhorn </v-icon> Annoucement</p>
                            
                            <p>{{announcement}}</p> 
                         </v-card> -->
                         
                        <v-alert
                        border="top"
                        color="green"
                        theme="dark"
                        icon="mdi-bullhorn"
                        
                        >
                        {{announcement}}
                        </v-alert>
                    </v-col>
                </v-row>
            </v-container>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-card class="pt-7 login-vcard" :style="{background: $vuetify.theme.themes['dark'].login_container_bg}">
                            <img style="width:180px;margin-left:auto;margin-right:auto;" class="d-block" :src="$siteLogo">
                            <div class="px-4 mt-5 pb-4">
                                <v-container fluid>
                                    <v-form @submit.prevent="login()" class="login-form">
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <span class="welcome-boss text-center">Welcome {{ $setPageTitle }}!
                                                    <!-- <span v-if="locationLabel"><br />{{ locationLabel }}</span> -->
                                                </span>
                                            </v-col>
                                            <v-col cols="12" :class="($currentLoginRole ? 'set-' + $currentLoginRole + '-account-icon' : '')">
                                                <v-text-field single-line solo autofocus v-model="form.username" label="Username" :error-messages="formerror.username" append-icon="mdi-account"></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field single-line solo v-model="form.password" label="Password" :error-messages="formerror.password" :append-icon="value ? 'mdi-eye-off-outline' : 'mdi-eye-outline'" @click:append="() => (value = !value)" :type="value ? 'password' : 'text'"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" class="mt-5">
                                                <v-btn block color="login_button" type="submit">LOGIN</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-container>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </section>
</template>

<script>
    export default {
        data(){
            return{
                value: String,
                overlay: false,
                formerror: {},
                announcement: null,
                form: new this.$Form({
                    username: '',
                    password: '',
                }),
            };
        },
        methods:{
            login(){
                this.form
                .post( this.$_CONFIG.api('API_LOGIN')).then((data) => {
                    this.$store.commit("loginSuccess", data.data);
                    
                    if(this.$store.state.hasAuthFactor){
                        this.$router.push({name: 'two_factor_auth'});
                    }else{
                        this.$router.push({name: 'dashboard'});
                    }
                }).catch((err) => {
                    this.formerror = err.response.data.errors;
                    if(err.response.data.message){
                        this.$toast.fire({ icon: 'error', title: err.response.data.message  });
                    }
                });
            },
            getannouncement(){
                this.$axios.get( this.$_CONFIG.api() + "/getannouncement").then((data) => {
                        this.announcement = data.data[0]['link'];
                        console.log(data)
                }).catch((err) => {});
            }
        },
        computed: {

        },
        created(){
            // console.log(this.$_.range(1, 3));
            // this.$toast.fire({ icon: 'error', title: "Some Error" });
            this.getannouncement();
        },
        mounted() {
            
        }
    }
</script>
